import React from 'react'
import LinkItem from 'components/Link'
import { UilAngleRight } from '@iconscout/react-unicons'
import ChecklistItem from './ChecklistItem'

const COLORS = {
  blue: { bg: 'bg-[#D5E6FD]', text: 'text-primary' },
  purple: { bg: 'bg-[#E2D1FD]', text: 'text-purple' },
  green: { bg: 'bg-[#C9F0D6]', text: 'text-success' }
}

export default function SectionCard({ icon: Icon, title, description, items = [], url, color = 'blue' }) {
  const { bg, text } = COLORS[color] || COLORS.blue

  return (
    <LinkItem
      url={url}
      classList="block bg-white rounded-2xl p-4 border border-border-lines shadow-sm hover:shadow-md transition-shadow h-full"
      tag={() => (
        <div className="w-full h-full flex flex-col">
          <div className="flex items-start gap-4 pb-4 border-b border-border-lines">
            <div className={`w-12 h-12 rounded-lg ${bg} flex items-center justify-center shrink-0`}>
              <Icon className={text} size={28} />
            </div>

            <div className="flex-1 min-w-0">
              <h3 className="text-base font-semibold text-dark-blue">{title}</h3>
              <p className="text-xs text-secondary mt-0.5">{description}</p>
            </div>

            <UilAngleRight className="text-secondary shrink-0" size={22} />
          </div>

          <ul className="flex flex-col pt-4 gap-1.5">
            {
              items.map((item) => <ChecklistItem key={item} text={item} color={text} />)
            }
          </ul>
        </div>
      )}
    />
  )
}
